<template>
  <div class="information-form">
    <Form ref="formInline" :show-message="false" :model="formInline" :rules="ruleInline" :label-width="180">
      <FormItem label="Name" prop="name">
        <!-- <Button type="primary" @click="$emit('handleDealer', false)">Primary</Button>
        <Button type="dashed" @click="$emit('handleDealer', true)">Dashed</Button> -->
        <div class="user-type">
          <span :class="isActiveDealer ? 'current' : ''" @click="isActiveDealer = true" data-type="dealer">Dealer</span>
          <span :class="isActiveDealer ? '' : 'current'" @click="isActiveDealer = false" data-type="freequote"
            >Free Quote</span
          >
        </div>
      </FormItem>
      <FormItem label="Name" prop="name">
        <Input v-model="formInline.name" placeholder="Please Enter Your Name"></Input>
      </FormItem>
      <FormItem label="Email" prop="email">
        <Input v-model="formInline.email" placeholder="Please Enter Your E-mail"></Input>
      </FormItem>
      <FormItem label="Phone" prop="phone">
        <Input v-model="formInline.phone" placeholder="Please Enter Your Phone Number"></Input>
      </FormItem>
      <FormItem prop="country" label="Country" @click="handleCountry">
        <!-- <Select clearable filterable v-model="formInline.country" placeholder="Please Select your Country">
          <Option v-for="item in countryList" :value="item.value" :key="item.value">{{ item.value }}</Option>
        </Select> -->
        <Cascader
          v-model="country"
          filterable
          placeholder="Please Select Country"
          :data="countryList"
          :load-data="loadData"
          @on-change="onChange"
        ></Cascader>
      </FormItem>
      <FormItem label="WhatsApp" prop="detailAddress">
        <Input v-model="formInline.detailAddress" placeholder="Please Enter your WhatsApp ID"></Input>
      </FormItem>
      <FormItem label="Products" prop="products">
        <Select clearable filterable v-model="formInline.products" placeholder="Please Select Product Category">
          <Option v-for="item in productList" :label="item.label" :value="item.value" :key="item.value">{{
            item.label
          }}</Option>
        </Select>
      </FormItem>
      <FormItem v-if="isActiveDealer" label="Company Name" prop="company">
        <Input v-model="formInline.company" placeholder="Please Enter Your Company Name"></Input>
      </FormItem>
      <FormItem v-if="!isActiveDealer" label="Message" prop="message">
        <Input
          style="width: 550px"
          v-model="formInline.message"
          type="textarea"
          class="message-input"
          :autosize="{ minRows: 3, maxRows: 5 }"
          placeholder="Please Enter Questions Or Suggestions"
        ></Input>
      </FormItem>
    </Form>
    <div class="bottom-desc m-a">
      <!-- <div class="ta-c contact">After submitting, our team will contact you soon.</div> -->
      <Checkbox class="d-b ta-c fs-12 ml-180 ta-c" :class="single ? '' : 'single-err'" v-model="single">
        <!-- Agree the-->

        FJDynamics is committed to protecting and respecting your privacy. By clicking the "Submit", you confirm that
        you have read and agreed to
        <nuxt-link class="nuxt-link" to="/privacypolicy"> FJDynamics ' Privacy Policy .</nuxt-link>

        FJDynamics may use your information to contact you about updates and special offers. You can unsubscribe at any
        time.
      </Checkbox>
      <button @click="handleSubmit('formInline')" class="submit-btn d-b c-p c-fff" type="button" id="submitTxt">
        Submit
      </button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {},
    data() {
      return {
        isActiveDealer: true,
        countryList: [], // 城市列表
        productList: [], // 产品列表
        single: true, // 是否同意隐私政策
        country: [], // 城市
        formInline: {
          // activityName: 'KOL',
          email: '',
          name: '',
          phone: '',
          country: '',
          province: '',
          detailAddress: '',
          company: '',
          products: '',
          // remark: '',
          languageCode: 'en-US',
          message: '',
          utmSource: '',
          utmCampign: '',
          utmMedium: '',
          utmAdset: '',
          utmContent: ''
        },
        ruleInline: {
          phone: [
            { required: true, message: 'Please Enter your Phone Number', trigger: 'blur' },
            // eslint-disable-next-line no-useless-escape
            { pattern: /^(\+?\s*\d+)(\s*|\-?|\d*)*\d$/g, message: 'Please Enter The correct cell phone number' }
          ],
          email: [
            { required: true, message: 'Please Enter your e-mail', trigger: 'blur' },
            { type: 'email', message: 'Incorrect Email Format', trigger: 'blur' }
          ],
          country: [{ required: true, message: 'Please Select Country', trigger: 'change' }],
          products: [{ required: true, message: 'Please Select Product Category', trigger: 'blur' }]
        }
      }
    },

    computed: {
      ...mapGetters({
        language: 'routerLang'
      })
    },
    mounted() {
      this.formInline = Object.assign(this.formInline, this.$route.query)
      // Promise.allSettled([this.getCountryList(), this.getInterestedProduct()])
      this.getCountryList()
      this.getInterestedProduct()
      // 合并 utm 参数
      // eslint-disable-next-line camelcase
      // const { utm_campaign, utm_content, utm_medium, utm_source } = this.$route.query
      // eslint-disable-next-line camelcase
      console.log('[ this.$route ] >', this.formInline)
    },
    methods: {
      handleCountry() {
        console.log('[ "asdjkashdjas" ] >', 'asdjkashdjas')
      },
      async getCountryList() {
        const { data } = await this.$api.retentionApi.getCountry('en')
        // console.log(data)
        data.forEach((item) => {
          //  229, 198, 207 这三个国家存在二级
          if ([229, 198, 207].includes(item.id)) {
            this.countryList.push({
              value: item.nameEn,
              label: item.nameEn,
              children: [],
              loading: false,
              fatherId: item.id
            })
          } else {
            this.countryList.push({
              value: item.nameEn,
              label: item.nameEn,
              // loading: false,
              fatherId: item.id
            })
          }
        })
      },
      async getInterestedProduct() {
        const data = await this.$api.common.getInterestedProduct({
          language: this.language
        })
        data.forEach((item) => this.productList.push({ label: item.productName, value: `${item.productId}` }))

        // console.log('[ language ] >', data)
      },
      // 级联选择 选择国家
      onChange(value) {
        const [country, province] = value
        this.formInline.province = province
        this.formInline.country = country
      },
      // 美国 加拿大等地还有二级区域
      async loadData(chooseItem, callback) {
        chooseItem.loading = true
        console.log('[ chooseItem ] >', chooseItem)
        const { data } = await this.$api.retentionApi.getCity({ fatherId: chooseItem.fatherId })
        if (!data.length) {
          chooseItem.loading = false
          this.formInline.country = chooseItem.nameEn
          this.country = [chooseItem.nameEn]
          return callback()
        }
        data.forEach((item) => {
          chooseItem.children.push({
            value: item.nameEn,
            label: item.nameEn,
            // children: [],
            // loading: false,
            fatherId: item.id
          })
        })
        chooseItem.loading = false

        callback()
        // getCity
      },
      handleSubmit(name) {
        // console.log(this.single, '[ this.single ] >', this.formInline)
        if (!this.single) {
          this.$Message.config({
            top: 99
          })
          return this.$Message.error('Please agree to the Privacy Policy')
        }
        this.$refs[name].validate(async (valid) => {
          if (valid) {
            const postUrlFn = this.isActiveDealer ? 'submitDealerForm' : 'toSubmitForm'
            const data = await this.$api.retentionApi[postUrlFn](this.formInline)
            if (data.status === 200) {
              this.showSuccessModal = true
              this.$refs[name].resetFields()
              this.$router.push('/result')
            }
            // this.$Message.success('Success!')
          } else {
            // this.$Message.error('Fail!')
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .form-content {
    margin: 0 3.8rem 0 2.6rem;
  }
  // form
  .information-form {
    margin: 0 3.8rem 0 2.6rem;

    .user-type span {
      display: inline-block;
      width: 83px;
      margin-right: 10px;
      line-height: 35px;
      text-align: center;
      color: #666;
      cursor: pointer;
      border: 1px solid #dbdbda;
      box-sizing: border-box;
      border-radius: 4px;
    }
    .user-type span:hover {
      border-color: #999;
    }
    .user-type .current {
      background-color: #333;
      border-color: #333;
      color: #fff;
    }
    .user-type .current:hover {
      border-color: #333;
    }
    .user-type span:last-child {
      width: 110px;
    }

    :deep(.ivu-form .ivu-form-item-label) {
      // width: 1.8rem;
      font-size: 0.18rem;
      padding: 0 0.16rem 0 0;
      text-align: right;
      font-weight: 500;
      color: #222;
      height: 0.5rem;
      line-height: 0.5rem;
    }
    :deep(.ivu-form-item) {
      .ivu-input {
        height: 0.5rem;
        line-height: 0.5rem;
        border-color: #bbbbbb;
        border-radius: 0;
        cursor: pointer;
        &:hover {
          border-color: #999999;
        }
        &:focus {
          box-shadow: none;
          border-color: #f2f2f2;
        }
      }
      // .ivu-input-type-textarea {
      //   height: 126px;
      // }
    }
    // 错误样式 普通input
    :deep(.ivu-form-item-error .ivu-input) {
      border: 1px solid #ed4014 !important;
      &:hover {
        border: 1px solid #ed4014 !important;
      }
    }
    // 下拉选择器
    :deep(.ivu-form-item-error .ivu-select-selection) {
      border: 1px solid #ed4014 !important;
      &:hover {
        border: 1px solid #ed4014 !important;
      }
    }
  }

  // 错误样式
  // :deep(.ivu-form-item-error){

  // }

  :deep(.ivu-select-not-found) {
    height: 0.5rem;
    line-height: 0.5rem;
  }
  // 下拉选择框
  :deep(.ivu-select-selection) {
    border: 1px solid #bbbbbb;
    &:hover {
      border-color: #999999;
    }
    &:focus {
      box-shadow: none;
      border-color: #f2f2f2;
    }
  }
  :deep(.ivu-select-single .ivu-select-selection .ivu-select-placeholder) {
    height: 0.5rem;
    line-height: 0.5rem;
  }

  :deep(.ivu-select-item) {
    &:hover {
      // color: #ffc550;
      background-color: #f0f0f0;
    }
    // border-bottom: 1px solid #eee;
    box-sizing: border-box;
    height: 0.5rem;
    line-height: 0.5rem;
    // margin: 0 25px;
    padding: 0 0 0 0.48rem;
  }
  :deep(.ivu-select-item-selected) {
    // color: #ffc550;
    background-color: transparent;
  }
  :deep(.ivu-select-dropdown) {
    max-height: 400px;
    // width: 100%;
    // height: 0.5rem;
    line-height: 0.5rem;
  }
  :deep(.ivu-select-single .ivu-select-selection) {
    height: 0.5rem;
    line-height: 0.5rem;
  }
  :deep(.ivu-select-single .ivu-select-selection .ivu-select-placeholder) {
    height: 0.5rem;
    line-height: 0.5rem;
  }

  :deep(.ivu-select-single .ivu-select-selection .ivu-select-selected-value) {
    height: 0.5rem;
    line-height: 0.5rem;
  }
  :deep(.ivu-select-visible .ivu-select-selection) {
    box-shadow: none;
  }

  // 级联选择器
  :deep(.ivu-cascader-menu) {
    height: 400px;
    width: 5rem;
    background-color: #fff;
    .ivu-cascader-menu-item {
      &:hover {
        background-color: #f0f0f0;
      }
      box-sizing: border-box;
      height: 0.5rem;
      line-height: 0.5rem;
      // margin: 0 25px;
      padding: 0 0 0 0.48rem;
    }
  }
  // 国家选择
  :deep(.ivu-cascader-label) {
    line-height: 0.5rem;
    height: 0.5rem;
  }
  :deep(.ivu-select-dropdown) {
    min-width: 50%;
  }
  // :deep(.ivu-cascader-not-found-tip) {
  //   width: 4.35rem;
  // }

  .bottom-desc {
    :deep(.ivu-checkbox-inner) {
      box-shadow: none;
    }
    .ivu-checkbox {
      margin-left: 10px;
    }
    // .single-err {
    //   :deep(.ivu-checkbox-inner) {
    //     border-color: #f24130 !important;
    //   }
    // }
    .contact {
      padding-top: 0.16rem;
      margin-bottom: 0.16rem;
      // height: 0.22rem;
      font-size: 0.16rem;
      font-weight: 400;
      color: #999999;
      // line-height: 0.19rem;
    }
    .nuxt-link {
      color: #666;
    }
    .submit-btn {
      margin: 0.42rem auto 0;
      background-color: #f0b900;
      width: 1.6rem;
      height: 0.42rem;
      color: #000;
      line-height: 40px;
      font-weight: 700;
      font-size: 20px;
    }
    .submit-btn:hover {
      background-color: #f0b900;
    }
    .ml-180 {
      margin-left: 180px;
    }
  }
</style>
